import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { BadgeComponent } from '../ui/badge.component/badge.component';
import { Project } from 'src/app/dto';



@Component({
  selector: 'app-project-card',
  standalone: true,
  imports: [CommonModule, RouterModule, BadgeComponent],
  templateUrl: './project-card.component.html'
})
export class ProjectCardComponent {
  @Input({ required: true }) project!: Project;

  get visibleTags(): string[] {
    return this.project?.tags?.slice(0, 3) ?? [];
  }

  get extraTagCount(): number {
    return Math.max((this.project?.tags?.length ?? 0) - 3, 0);
  }
}
